
import {Component, Vue} from 'vue-property-decorator';
import Header from "@/components/Header.vue";
import LandingSection from "@/components/LandingSection.vue";
import PlatformChoice from "@/components/PlatformChoice.vue";
import DownloadWin33 from "@/components/DownloadWin33.vue";
import DownloadMac33 from "@/components/DownloadMac33.vue";
import DownloadLin33 from "@/components/DownloadLin33.vue";
import DownloadZip33 from "@/components/DownloadZip33.vue";
import License from "@/components/License.vue";
import {gaSendPageview} from "@/components/Analytics";
import Cookies from "js-cookie";
import DownloadWin34 from "@/components/DownloadWin34.vue";
import DownloadMac34 from "@/components/DownloadMac34.vue";
import DownloadLin34 from "@/components/DownloadLin34.vue";
import DownloadZip34 from "@/components/DownloadZip34.vue";
import {destroyGanalytics, installGanalytics} from "@/components/Tracker";

@Component({
  components: {
    DownloadZip34,
    DownloadLin34,
    DownloadMac34,
    DownloadWin34,
    DownloadZip33, DownloadLin33, DownloadMac33, DownloadWin33, LandingSection, Header, PlatformChoice, License}
})
export default class Download34 extends Vue {
  private versionShort = "3.4";
  private version = "3.4.3396";
  private releaseDate = "14 Sep, 2026";
//    private isPaidDownload = false;
  private winMsiSize = "175 Mb";
  private winMsiMd5 = "878973262a11d473b6dc3177ec2376f4";
  private winMsiVirusTotal = "d7962c813f1dc511a81046d4b6961ebf619f55e323e20469cadc24ba33f571a3";
  private winExeSize = "173 Mb";
  private winExeMd5 = "77d758e58afedcaf85fa51d28a0c9859";
  private winExeVirusTotal = "fa445eb4c78c159c3d610ca3480df15d637924746718e141f0e1e38e5ce80a47";
  private macSiliconSize = "176 Mb";
  private macIntelSize = "180 Mb";
  private linDebSize = "87 Mb";
  private linAppimageSize = "178 Mb";
  private zipSize = "80 Mb";

  constructor() {
    super();
  }
  private cdnUrl(path: string): string {
    return path;
  }

  public mounted() {
    gaSendPageview();
    installGanalytics();
  }

  public beforeDestroy() {
    destroyGanalytics();
  }
}
